export default __webpack_public_path__ + "static/media/1168.b8a40ed4.png";